module.exports = __webpack_public_path__ + "img/bg_download_app_mobile.874c3e6.png";